import React from "react";
export function Card({ className = "", ...props }) {
    return (
        <div
            className={`rounded-2xl border border-gray-200 bg-white shadow-sm ${className}`}
            {...props}
        />
    );
}

export function CardHeader({ className = "", ...props }) {
    return (
        <div
            className={`border-b border-gray-100 px-4 py-3 flex items-center justify-between ${className}`}
            {...props}
        />
    );
}

export function CardTitle({ className = "", ...props }) {
    return (
        <h2
            className={`text-lg font-semibold text-gray-800 ${className}`}
            {...props}
        />
    );
}

export function CardDescription({ className = "", ...props }) {
    return (
        <p
            className={`text-sm text-gray-500 ${className}`}
            {...props}
        />
    );
}

export function CardContent({ className = "", ...props }) {
    return <div className={`p-4 ${className}`} {...props} />;
}